import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import uploadoss from '@/components/uploadoss'
import login from '../login/login'
import common from '../../common/common'
export default {
name: 'postDemand',
directives: {
TransferDom
},
components: {
XDialog,uploadoss,'login': login,
},
data () {
return {
requireType:'仿真人像',
name:'',
len:'',
width:'',
height:'',
qty:'',
price:'',
phone:'',
remark:'',
referencePrice:'',//
fileArr:[],
uploadFileName:'',//oss上传文件名
phoneReg: /^1[3456789]\d{9}$/,  //手机号正则!this.phoneReg.test(phone)
showToast:false,//成功提示
loginShow:false,//登录
}
},
methods: {
showossdata(data) {
this.ossdata = data;
this.uploadFileName = data[0].name
},
showossurl(fileArr) {
this.fileArr.push({fileName:fileArr[0].fileName,path:fileArr[0].path})
},
changeType(checked){
this.requireType = checked
},

getReferencePrice(){
if(this.qty){
let partSizeArr = []
partSizeArr.push(this.len)
partSizeArr.push(this.width)
partSizeArr.push(this.height)
this.$request.post('/designtask/referencePrice',{
designTask:{
requireType:this.requireType,
detail:Math.max.apply(null, partSizeArr),
pieceCount:this.qty,
}
}).then((res)=>{
this.referencePrice = res.obj
})
}

},

reset(){
this.name=''
this.len=''
this.width=''
this.height=''
this.qty=''
this.price=''
this.referencePrice='0'
this.phone=''
this.remark=''
this.fileArr=[]
this.uploadFileName=''
},

submit(){
if(this.name == '') {
this.$vux.toast.show({
type: 'warn',
text: '请输入项目名称'
})
return false
}
if(this.len == ''||this.width == ''||this.height == '') {
this.$vux.toast.show({
type: 'warn',
text: '请输入产品尺寸'
})
return false
}
if(this.qty =='') {
this.$vux.toast.show({
type: 'warn',
text: '请输入拆件数量'
})
return false
}
if(this.price =='') {
this.$vux.toast.show({
type: 'warn',
text: '请输入建模赏金'
})
return false
}
if(this.phone =='') {
this.$vux.toast.show({
type: 'warn',
text: '请输入联系手机'
})
return false
}
if(!this.phoneReg.test(this.phone)) {
this.$vux.toast.show({
type: 'warn',
text: '请输入合法的手机号'
})
return false
}
if(common.getCookie('_token') == null) {
this.loginShow = true;
return false;
}
this.$request.post('designtask/insert',{
designTask:{
requireType: this.requireType,
projectType: '',
title: this.name,//项目名称
detail: this.len+'*'+this.width+'*'+this.height,
pieceCount: this.qty,
price: this.price,//价格
referPrice: this.referencePrice,//参考价
reqdate: '',
phone: this.phone,
qq: '',
mailbox: '',
remarks:this.remark,//备注
},
listDesignTaskFile:this.fileArr,
}).then((res)=>{
if(res.code == 0){
this.showToast = true
this.reset()
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}

})
},

loginCallback(status, response) {

if(response.code == 0) {
this.loginShow= false
this.$vux.toast.show({
type: 'success',
text: '登录成功'
})
setTimeout(()=>{





},1000)
}
},
},
computed: {

},
created () {

}
}



// WEBPACK FOOTER //
// ./src/views/postDemand/script.js